export default "__VITE_ASSET__Dj5B9kfF__"